var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameExitSmallFullScreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.869 12.9643C135.006 13.0341 130.189 17.766 130.555 23.8078L130.975 108.54C131.004 114.44 135.748 119.237 141.474 119.21L226.76 118.801C230.178 118.866 232.931 117.589 234.799 115.494C236.627 113.442 237.473 110.763 237.46 108.181C237.447 105.6 236.575 102.929 234.723 100.901C232.831 98.8297 230.063 97.5943 226.649 97.7081L152.105 98.0655L151.736 23.6323C151.708 17.8528 147.052 12.5912 140.869 12.9643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.618 237.485C114.481 237.443 119.321 232.734 118.985 226.691V141.958C118.985 136.058 114.265 131.238 108.539 131.238H23.2528C19.8349 131.156 17.0755 132.42 15.1972 134.506C13.3589 136.549 12.5 139.224 12.5 141.806C12.5 144.387 13.3589 147.062 15.2012 149.099C17.0829 151.179 19.8444 152.428 23.259 152.331H97.8034V226.765C97.8034 232.544 102.433 237.828 108.618 237.485Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameExitSmallFullScreenIcon);
export default __webpack_public_path__ + "static/media/game_exit-small-full-screen_icon.d147b6b78bcfdb9b34f5afee0175d36d.svg";
export { ForwardRef as ReactComponent };